module.exports = __webpack_public_path__ + "static/media/sms6.9fc91b1f.png";